import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    plans: JSON.parse(localStorage.getItem('plans')) || [],
    categories: JSON.parse(localStorage.getItem('categories')) || [],
    tradingPlans: JSON.parse(localStorage.getItem('tradingPlans')) || [],
}

export const plansSlice = createSlice({
    name: 'plans',
    initialState,
    reducers: {
        setPlans: (state, action) =>{
            state.plans = action.payload;  
            localStorage.setItem('plans', JSON.stringify(state.plans));
        },

        setCategories: (state, action) =>{
            state.categories = action.payload;  
            localStorage.setItem('categories', JSON.stringify(state.categories));
        },


        setTradingPlans: (state, action) =>{
            state.tradingPlans = action.payload;  
            localStorage.setItem('tradingPlans', JSON.stringify(state.tradingPlans));
        }

    }
})

export const {setPlans, setCategories, setTradingPlans} = plansSlice.actions;
export default plansSlice.reducer;